<template>
  <span class="spinner-border spinner-border-sm position-absolute mt-1"
    :class="{
      'start-0 end-0 top-0 bottom-0': displayCenter,
      'me-auto ms-auto mt-auto mb-auto': displayCenter,
      'start-0 ms-4': !displayEnd,
      'end-0 me-4': displayEnd
    }"
  ></span>
</template>

<script setup>
const props = defineProps({
  displayEnd: {
    type: Boolean,
    default: false
  },
  displayCenter: {
    type: Boolean,
    default: false
  }
})

</script>

<style lang="scss" scoped>
</style>
